export class AuthHandlerException extends Error {
  errors: object

  constructor(response: any) {
    super(JSON.stringify(response))
    this.errors = response.data
    this.name = 'AuthHandlerException'
  }
}

export class RateLimitedException extends Error {
  errors: object

  constructor(message: any, cause?: any) {
    super(message)
    this.cause = cause
    this.name = 'RateLimitedException'
    this.errors = { non_field_errors: [message] }
  }
}

export class LoginPermissionDeniedException extends Error {}

export class OneTimeTokenRequiredException extends Error {
  constructor(message: any, cause?: any) {
    super(message)
    this.cause = cause
    this.name = 'OneTimeTokenRequiredException'
  }
}

export class OneTimeTokenExpiredException extends Error {
  constructor(message: any, cause?: any) {
    super(message)
    this.cause = cause
    this.name = 'OneTimeTokenExpiredException'
  }
}

export class OneTimeTokenInvalidException extends Error {
  constructor(message: any, cause?: any) {
    super(message)
    this.cause = cause
    this.name = 'OneTimeTokenInvalidException'
  }
}
